import { ElMessage } from "element-plus";

export const errorAlert = (err) => {
  let msg = err;
  ElMessage({
    type: "error",
    message: msg,
  });
};
